import styled from 'styled-components';
import { colors } from '@prisjakt/ui-base';

export const LayoutPicker = styled.div.attrs({ 'data-test': 'LayoutPicker' })`
  align-self: stretch;
  display: flex;
  justify-content: center;
`;

export const Button = styled.button`
  outline: none;
  cursor: pointer;
  padding: 0 8px;
  position: relative;
  fill: ${colors.mediumGray1};
  &:hover {
    svg g,
    svg path {
      fill: ${colors.lightTheme.maybeBlue500};
    }
  }
`;
